import React from 'react';
import { ListItem, ListItemContent, Box } from "@mui/joy";
import { Button } from '../Button';

import { useTranslation } from 'react-i18next'
import PersonAvatar from '../Snippet/PersonAvatar';
import { Icon } from '../../assets';
import { isDocumentMediaPath } from 'src/mtska-frontend-data-provider/redux/downloadDocumentMedia';
import { useResolvedMediaSrc } from 'src/mtska-frontend-data-provider/hooks/useResolvedMediaSrc';

const RelationshipDriverDelegate = ({ k, v, editing, detailInspector = true, handleItemDetail, handleItemRemove, loadingDissociation }) => {
    const { t } = useTranslation();
    const printableExtensions = ['JPG', 'JPEG', 'PNG', 'SVG', 'WEBP'];
    const isPrintable = printableExtensions.includes(v?.authorizationextension?.toUpperCase());
    const previewUrl = isPrintable && v?.url ? v.url : null;
    const { src, ready } = useResolvedMediaSrc(
        previewUrl && isDocumentMediaPath(previewUrl) ? previewUrl : null
    );
    const previewSrc = previewUrl && isDocumentMediaPath(previewUrl)
        ? (ready ? src : null)
        : previewUrl;

    return (
        <ListItem key={k} variant="outlined" className={"relationship-element"}>
            <ListItemContent className={"relationship-element-content"}>
                <PersonAvatar firstname={v?.firstname} lastname={v?.lastname} url={v?.url} item={v}/>
                <Box className="name">
                    <span className="name">{v?.firstname + " " + v?.lastname}</span>
                </Box>
                <Box className={"coupled relativitydegree"}>
                    <span className={"label"} >{t('Relative')}</span>
                    <span className={"value"} title={t(v?.relationship)}>{t(v?.relationship)}</span>
                </Box>
                <Box className={"coupled licence"}>
                    <span className={"label"} >{t('Driver licence')}</span>
                    <span className={"value"} title={t(v?.licenceid)}>{t(v?.licenceid)}</span>
                </Box>
                <Box className={"icon-file icon-" + (isPrintable ? 'preview' : 'type')}>
                    {
                        isPrintable && previewSrc && (
                            <img src={previewSrc} className="filepreview" alt="" />
                        )
                    }
                    {
                        isPrintable && !previewSrc && (
                            <Icon icon="faFile" className="fileicon" />
                        )
                    }
                    {
                        !isPrintable && (
                            <>
                                <Icon icon="faFile" className="fileicon" />
                                <Box className="extension">{v?.authorizationextension}</Box>
                            </>
                        )
                    }
                </Box>
                <Box className={"authorization norightborder"}>
                    <span className={"label"} >{t('Co-driver authorization')}</span>
                </Box>
            </ListItemContent>

            {(editing && handleItemRemove) && (<Button onClick={() => handleItemRemove(v)} icon="faClose" variant="plain" loading={loadingDissociation} />)}
        </ListItem>
    )
}

export default RelationshipDriverDelegate
